import React from 'react';
import { CheckIcon } from 'lucide-react';
const audiences = [{
  icon: '🏥',
  title: 'Veterinarios clínicos',
  description: 'Atendés pacientes todo el día y el papeleo te roba tiempo que deberías dedicarle a los animales. Con el Kit Elite tenés todo organizado desde el primer día.',
  benefits: ['Historia clínica completa por paciente', 'Seguimiento de tratamientos y controles']
}, {
  icon: '🏢',
  title: 'Dueños de clínica',
  description: 'Tenés un equipo y necesitás que todos trabajen con el mismo sistema. El Kit Elite estandariza la gestión de toda tu clínica.',
  benefits: ['Gestión de turnos y agenda profesional', 'Control de inventario y stock de medicamentos']
}, {
  icon: '🎓',
  title: 'Veterinarios recién recibidos',
  description: 'Arrancás tu consultorio y no sabés por dónde empezar con la parte administrativa. El Kit Elite te da la estructura que tardás años en armar solo.',
  benefits: ['Todo listo para usar desde cero', 'Compatible con Excel y Google Sheets']
}];
export function ForWho() {
  return <section className="bg-navy text-white py-12 px-6" data-id="element-124">
      <div className="max-w-md mx-auto space-y-8" data-id="element-125">
        <h2 className="text-2xl font-bold text-center" data-id="element-126">
          ¿Este kit es para vos?
        </h2>

        <div className="space-y-6" data-id="element-127">
          {audiences.map((audience, index) => <div key={index} className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-6 space-y-4" data-id="element-128">
              <div className="flex items-center gap-3" data-id="element-129">
                <span className="text-3xl" data-id="element-130">{audience.icon}</span>
                <h3 className="text-xl font-bold" data-id="element-131">{audience.title}</h3>
              </div>

              <p className="text-[15px] leading-relaxed opacity-90" data-id="element-132">
                {audience.description}
              </p>

              <div className="space-y-2 pt-2" data-id="element-133">
                {audience.benefits.map((benefit, idx) => <div key={idx} className="flex items-start gap-2" data-id="element-134">
                    <CheckIcon className="w-5 h-5 text-teal-bright flex-shrink-0 mt-0.5" data-id="element-135" />
                    <span className="text-sm opacity-90" data-id="element-136">{benefit}</span>
                  </div>)}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}